import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import _ from "lodash";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/**
 *
 * @param {Array} arr -> [{key, value}, {key, value}, etc]
 * @returns Object -> {key: value}
 */
export const convertArrayToObject = (arr = []) => {
    if (!Array.isArray(arr)) {
        console.log(`[ERROR] given input is not an Array`);
        return {};
    }
    return arr.reduce((acc, curr) => {
        acc[curr.key] = curr.value;
        return acc;
    }, {});
};
export function isFiniteNumber(value) {
    return Number.isFinite(value);
}
/**
 * Column configuration mapping.
 *
 * Example:
 * {
 *   "Estimated Price": {
 *     visibleFor: ["PA", "EA", "EU"],
 *     valueKey: "Estimated",
 *     condition: true
 *   },
 *   "Final Price": {
 *     valueKey: "Final",
 *     condition: false
 *   },
 *   "Reversed Units": {
 *     visibleFor: ["PA", "EA", "EU"],
 *     valueKey: ["Reversed", "Adjusted"],
 *     fun: (reversed, adjusted) => `${reversed} / ${adjusted}`
 *   }
 * }
 *
 * @typedef {Object.<string, {
 *   visibleFor?: string[],          // Roles that can see the column
 *   valueKey: string | string[],    // Key(s) from the row object to use
 *   condition?: boolean,            // Whether the column should be displayed
 *   fun?: (...args: any[]) => any   // Custom function to compute value when multiple keys are given
 * }>} ColMap
 */
/**
 * Filters and maps column configuration based on user role.
 *
 * @param {ColMap} colMap - The column configuration map.
 * @param {string} loggedInRole - The role of the logged-in user (e.g., "EA", "PA", "EU").
 * @returns {Object.<string, {
 *   getValue: (row: Object, defaultVal?: any) => any,
 *   original: any
 * }>} A mapping of visible column names to:
 *   - `getValue`: function to extract or compute the column value from a row.
 *   - `original`: the original column configuration object.
 */
export function getTableCol(colMap, loggedInRole) {
    try {
        if (!loggedInRole)
            throw new Error(`"loggedInRole" is required`);
        if (!colMap)
            throw new Error(`"colMap" is required`);
        const _r = loggedInRole;
        const _v = ["PA", "EA", "EU", "ESU"]; // defaultVisibility
        const column = Object.keys(colMap);
        const result = column
            .filter((key) => {
            let col = _.get(colMap, key, {});
            const condition = _.get(col, "condition", true);
            const visibility = _.get(col, "visibleFor", _v).includes(_r);
            return condition && visibility;
        })
            .reduce((acc, cur) => {
            const mObj = colMap[cur];
            acc[cur] = {
                getValue: (ele, defaultVal = "-") => {
                    var _a;
                    const keys = mObj.valueKey;
                    if (typeof keys === "string")
                        return (_a = ele[keys]) !== null && _a !== void 0 ? _a : defaultVal;
                    if (Array.isArray(keys)) {
                        if (typeof mObj.fun === "function") {
                            const valArr = keys.map((_k) => { var _a; return (_a = ele[_k]) !== null && _a !== void 0 ? _a : ""; });
                            return mObj.fun(...valArr);
                        }
                    }
                    return defaultVal;
                },
                original: mObj,
            };
            return acc;
        }, {});
        return result;
    }
    catch (error) {
        console.log(`[ERROR][getTableCol] not able to filter`, error);
        return {};
    }
}
